/// <reference path="Chart.js" />
import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import moment from 'moment';
import Frame from './Frame';
import IFrame from './IFrame';
import { userService } from '../_services';
import loader from '../../src/components/css/dark/img/loader.gif';
if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
    import("./css/dark/rxhacker.css")
} else {
    import("./css/dark/main.css")
}
const { AbortController } = window;

class Piechart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            PieChartData: null,
            options: {
                maintainAspectRatio: false,
            },
            IsDataLoaded: false,
            XlabelString: this.props.XlabelString,
            YlabelString: this.props.YlabelString,
            IFrameId: this.props._Index,
            PostData: this.props.PostData
        };
        this.abortController = null;
        this.debounceTimer = null;

    }

    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Pie") {
            this.Fetch_RawData();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "Pie") {
            this.Fetch_RawData();
        }
        window.Chart.defaults.global.defaultFontFamily = `'Fira Sans', sans-serif`;
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }
    Fetch_RawData() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();


        this.setState({
            IsDataLoaded: false
        });
        const requestOptions = {
        method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: this.props.PostData
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
        .then(dataset => {
            try {
                var dataset2 = new Array();
                dataset2.push({ labels: dataset[0].labels, datasets: [{ data: dataset[0]["datasets"][0].data, backgroundColor: dataset[0]["datasets"][0].backgroundColor, hoverBackgroundColor: dataset[0]["datasets"][0].hoverBackgroundColor }] });
                if (dataset) {
                    this.setState({
                        ...this.state,
                        IsDataLoaded: true,
                        PieChartData: dataset2[0],
                        options: {
                            legend: {
                                display: false
                            },
                            elements: {
                                arc: {
                                    borderWidth: 0
                                }
                            },
                            tooltips: {
                                backgroundColor: '#fff',
                                titleFontColor: '#8ba6c1',
                                borderWidth: 1,
                                borderColor: '#dde5ed',
                                titleFontFamily: 'Apercu-Regular',
                                titleFontSize: 12,
                                bodyFontFamily: 'Apercu-Regular',
                                bodyFontSize: 16,
                                bodyFontColor: '#1d252d',
                                xPadding: 10,
                                titleFontStyle: "normal",
                                bodyFontStyle: 600,
                                tooltipFontFamily: 'Apercu-Regular'
                            },
                            responsive: true
                        }
                    });
                }
                else {
                }
            }
            catch (error) {
            }
            return dataset;
        }).catch(err => {
            if (err.name === "AbortError") {
                // Expected cancel, just ignore
                //console.log("Fetch request aborted");
                return;
            }
            // Unexpected error
            //console.error("Fetch error:", err);
            this.setState({
                IsDataLoaded: true,
                noDataDisplay: 'Error while loading data'
            });
        });
    }

    handleResponse(response) {
        return response.text().then(text => {
        const data = text && JSON.parse(text);
        return data;
    });
}
    render() {
        return (
            <div>
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>)}
            <Frame id={this.state.IFrameId} scrolling="no" key={"graph-frame" + this.state.IFrameId}>
            <div className="PieChart">               
                {
                    this.state.PieChartData != null ? <Pie data={this.state.PieChartData} options={this.state.options} /> : null
                }
                </div>
                </Frame>
                </div>
        )

    }


}
export default Piechart;